<template>
  <b-container fluid class="container-layout">
    <b-row align-h="center">
      <p class="title mt-4">CARRERA: {{carrera | upper}}</p>
    </b-row>
    <b-row align-h="center">
      <p class="subtitle mt-4">Tu puntaje obtenido es:</p>
    </b-row>
    <b-row align-h="center">
      <p class="title mt-4">
        {{total.puntaje_total}}
        <span class="points">sobre un total de</span>
        {{total.tatal_puntaje}}
        <span class="points">puntos</span>
      </p>
    </b-row>
    <b-row align-h="center">
      <p :style="aprobado===false ? 'color:red!important':''" class="title mt-4">{{title}}!</p>
    </b-row>
    
    <!--texto else-->
    <b-row align-h="center">
      <p class="block mt-3">
        Si usted hubiera postulado por
        <strong>Examen de Admisión Regular</strong>
        {{afir}} hubiera
        pertenecido a nuestra casa de estudios.
      </p>
    </b-row>
    <!--texto else-->
    <b-row align-h="center">
      <p class="mt-2 info-result">
        Para mayor información sobre el Examen de Admisión Regular puedes dar clic al
        siguiente link:
      </p>
      <br />
    </b-row>
    <b-row align-h="center">
      <a target="_blank" href="https://admision.ucsp.edu.pe">https://admision.ucsp.edu.pe/</a>
    </b-row>
    <b-row align-h="center">
      <p class="mt-5 resume-result">Resumen de su Examen Simulacro</p>
      <br />
    </b-row>
    <b-row class="mt-2" align-h="center">
      <b-col cols="10">
        <b-table-simple class="table-result" striped hover responsive>
          <b-thead class="thead-table">
            <b-tr>
              <b-th class="table-th-1 text-center" rowspan="2" colspan="2">Modulo</b-th>
              <b-th class="text-center" colspan="4">Preguntas</b-th>
              <b-th class="table-th-2 text-center" rowspan="2" colspan="2">Puntaje</b-th>
            </b-tr>
            <b-tr>
              <b-th class="text-center">Formulas</b-th>
              <b-th class="th-border-1 text-center">Correctas</b-th>
              <b-th class="th-border-2 text-center">Incorrectas</b-th>
              <b-th class="text-center">En blanco</b-th>
            </b-tr>
          </b-thead>
          <b-tbody class="body-result">
            <tr class="puntajes-module" v-for="(item, key) in resultados" :key="key">
              <td class="title-module" colspan="2">{{item.titulo}}</td>
              <td>{{item.formuladas}}</td>
              <td>{{item.correctas}}</td>
              <td>{{item.incorrectas}}</td>
              <td>{{item.enBlanco}}</td>
              <td>{{item.puntaje_total}}</td>
            </tr>
            <tr class="total-module">
              <td class="title-module" colspan="2">Total</td>
              <td>{{total.preguntas_formuladas}}</td>
              <td>{{total.preguntas_correctas}}</td>
              <td>{{total.preguntas_incorrectas}}</td>
              <td>{{total.preguntas_en_blanco}}</td>
              <td>{{total.puntaje_total}}</td>
            </tr>
          </b-tbody>
        </b-table-simple>
      </b-col>
    </b-row>
    <b-row align-h="center" class="mt-5">
      <p class="title-diagram-1 diagram">
        "A continuacion puedes observar
        <span style="background-color: #583C89;color: white; padding: 5px;">TUS RESULTADOS</span> vs, el
        <span style="background-color: #9CCB48;color: white; padding: 5px;">PROMEDIO</span> de tu aula por cada
        Módulo"
      </p>
    </b-row>
    <b-row align-h="center" class="mt-3">
      <ChartResultadoxPromedio :resultados="resultados" />
    </b-row>
    <b-row align-h="center" class="mt-5">
      <p class="title-diagram">
        "
        <span style="background-color: #583C89;color: white; padding: 5px;">TU PUNTAJE</span> vs. el
        <span style="background-color: #FEC32B;color: white; padding: 5px;">PUNTAJE MÁXIMO</span>
        de tu aula, por cada módulo”
      </p>
    </b-row>
    <b-row align-h="center" class="mt-3">
      <ChartPuntajeMaximo />
    </b-row>
    <b-row align-h="center" class="mt-5">
      <p
        class="title-diagram"
      >"Cantidad de estudiantes por Carrera que rendieron el Examen Simulacro - 5to B "</p>
    </b-row>
    <b-row align-h="center" class="mt-3">
      <ChartEstudiantesxCarrera />
    </b-row>
    <b-row align-h="center" class="mt-5">
      <!--<p @click="imprimir()" class="title-diagram">Descargar Resultados</p>-->
      <b-col cols="12" class="mt-2" style="text-align: center">
        <span @click="imprimir()">
          <img :src="srcImagen('pdf.svg')" class="results-pdf-img" alt />
          <a class="results-dowload">DESCARGAR RESULTADOS</a>
        </span>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import ChartResultadoxPromedio from "@/components/Global/ChartResultadoxPromedio";
import ChartPuntajeMaximo from "@/components/Global/ChartPuntajeMaximo";
import ChartEstudiantesxCarrera from "@/components/Global/ChartEstudiantesxCarrera";

export default {
  name: "ResultsStudianteId",
  components: {
    ChartResultadoxPromedio,
    ChartPuntajeMaximo,
    ChartEstudiantesxCarrera
  },
  props: {
    puntaje: String,
    total: Object,
    resultados: Array,
    carrera: String,
    aprobado: Boolean
  },
  data: () => ({
    key: localStorage.getItem('idkey')
  }),
  methods: {
    imprimir() {
      window.print();
    },
    goRouter(url) {
      this.$router.push(url);
    },
    srcImagen(img) {
      let src = require("@/assets/images/" + img);
      return src;
    }
  },
  filters: {
    upper: function(value) {
      return value.toUpperCase();
    }
  },
  computed: {
    title() {
      return this.aprobado === true ? "Felicidades" : "No alcanzaste el puntaje";
    },
    afir() {
      return this.aprobado === true ? "" : "NO";
    }
  }
};
</script>
<style scoped>
</style>
